import { Component, computed, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

@Component({
  selector: 'app-markdown-preview',
  standalone: true,
  template: `<div class="md-body" [innerHTML]="html()" dir="auto"></div>`,
  styleUrl: './markdown-preview.component.scss',
})
export class MarkdownPreviewComponent {
  readonly source = input<string>('');

  private readonly sanitizer: DomSanitizer;

  constructor(sanitizer: DomSanitizer) {
    this.sanitizer = sanitizer;
    marked.setOptions({ breaks: true, gfm: true });
  }

  readonly html = computed<SafeHtml>(() => {
    const src = this.source() ?? '';
    if (!src.trim()) return '';
    const raw = marked.parse(src, { async: false }) as string;
    const withDirs = raw.replace(
      /<(p|h[1-6]|li|blockquote|td|th)(\s[^>]*)?>/g,
      '<$1$2 dir="auto">',
    );
    const clean = DOMPurify.sanitize(withDirs, {
      ADD_ATTR: ['dir'],
    });
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  });
}
